<mat-spinner *ngIf="isLoading$ | async; else logo"></mat-spinner>
<ng-template #logo>
	<div class="railroad-logo">
		<img [src]="logo$ | async" />
		<div fxLayout="column" fxLayoutAlign="center stretch">
			<input
				hidden
				type="file"
				#fileInput
				(change)="uploadLogo($event)"
			/>
			<button
				type="button"
				mat-button
				(click)="fileInput.click()"
				[ngStyle]="{
					height: (isDefaultLogo$ | async) ? '100%' : '50%'
				}"
			>
				Update Logo
			</button>
			<button
				*ngIf="!(isDefaultLogo$ | async)"
				rpsharedConfirm="Remove logo?"
				(onConfirmed)="removeLogo()"
				mat-button
			>
				Remove Logo
			</button>
		</div>
	</div>
</ng-template>
